import { __awaiter, __generator } from "tslib";
import { fetchGet } from '../../common/http/fetch-get';
import { fetchCartSetting } from '../site-settings/fetch-cart-setting';
import { fetchToken } from './fetch-token';
import { combineUrl } from './utilities/combine-url';
export var fetchCart = function () { return __awaiter(void 0, void 0, void 0, function () {
    var cartSetting, token, cartUrl, headers;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetchCartSetting()];
            case 1:
                cartSetting = _a.sent();
                if (!cartSetting) {
                    return [2 /*return*/, Promise.resolve(null)];
                }
                return [4 /*yield*/, fetchToken()];
            case 2:
                token = _a.sent();
                if (!token) {
                    return [2 /*return*/, Promise.resolve(null)];
                }
                cartUrl = combineUrl(cartSetting.cartUrl, {
                    format: 'json',
                    method: 'get',
                    token: token.access_token,
                });
                headers = new Headers();
                headers.set('Authorization', "Bearer " + token.access_token);
                return [4 /*yield*/, fetchGet(cartUrl, { headers: headers, mode: 'no-cors' })
                        .then(function (response) { return response ? response.cart : null; })];
            case 3: return [2 /*return*/, _a.sent()];
        }
    });
}); };
